export const TABOOLA_PUBLISHER_ID = "sphmedia-businesstimes";
export const TABOOLA_SCRIPT = `
  !function (e, f, u, i) {
    if (!document.getElementById(i)) {
      e.async = 1;
      e.src = u;
      e.id = i;
      f.parentNode.insertBefore(e, f);
    }
  }(document.createElement('script'),
    document.getElementsByTagName('script')[0],
    '//cdn.taboola.com/libtrc/${TABOOLA_PUBLISHER_ID}/loader.js',
    'tb_loader_script');
  if(window.performance && typeof window.performance.mark == 'function')
    {window.performance.mark('tbl_ic');}
`;
